export default "__VITE_ASSET__855c5923__"